require('./tooltip.scss');

const template = require('./tooltip.html');

const deps = [];

module.exports = angular.module('bench.ui.tooltip', deps).component('blTooltip', {
  bindings: {
    message: '@',
    position: '@',
    styleType: '@',
  },
  template,
  transclude: true,
  controllerAs: 'vm',
});
